import * as React from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Box,
  DialogTitle,
  Stack,
  InputLabel,
  Typography,
} from "@mui/material/";
import CloseIcon from "@mui/icons-material/Close";
import "./../genericModels.css";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useTranslation } from "react-i18next";

const PromoIncreaseModal: any = (props: any) => {
  const { t } = useTranslation(["operation"]);
  const dataFormSearchEdit = props.dataFormSearch;
  //const setOpenModalPerFilters = props?.setOpenModalPerFilters;
  let supplierId2 = props.supplierId;
  let setDataFormSearch = props.setDataFormSearch;

  const closeAddMaintenanceModal = () => {
    setDataFormSearch({
      startDate: "",
      endDate: "",
      percentage: "",
    });
    props.setOpenModalPerFilters(false);
  };

  let validateForm = {
    startDate: Yup.date()
      .required(t("transportSupplierPriceList.addEditPromo.startDateRequired"))
      .typeError(t("transportSupplierPriceList.addEditPromo.startTypeError")),
    endDate: Yup.date()
      .required(t("transportSupplierPriceList.addEditPromo.endDateRequired"))
      .typeError(t("transportSupplierPriceList.addEditPromo.endTypeError")),

    percentage: Yup.number()
      .required(t("transportSupplierPriceList.addEditPromo.percentageRequired"))
      .typeError(
        t("transportSupplierPriceList.addEditPromo.percentageTypeError")
      ),
  };

  if (!dataFormSearchEdit.editId) {
    validateForm = {
      startDate: Yup.date()
        .required(
          t("transportSupplierPriceList.addEditPromo.startDateRequired")
        )
        .typeError(t("transportSupplierPriceList.addEditPromo.startTypeError")),
      endDate: Yup.date()
        .required(t("transportSupplierPriceList.addEditPromo.endDateRequired"))
        .typeError(t("transportSupplierPriceList.addEditPromo.endTypeError")),

      percentage: Yup.number()
        .required(
          t("transportSupplierPriceList.addEditPromo.percentageRequired")
        )
        .typeError(
          t("transportSupplierPriceList.addEditPromo.percentageTypeError")
        ).test(
          "The percentage must not be zero",
          t("transportSupplierPriceList.addEditPromo.percentageNotZero"),
          function (percentage:any) {
           if (percentage === 0) {
            return false
           } else {
            return true
           }
          }
        ),
    };
  } else if (dataFormSearchEdit.id) {
    validateForm = {
      startDate: Yup.date()
        .required(
          t("transportSupplierPriceList.addEditPromo.startDateRequired")
        )
        .typeError(t("transportSupplierPriceList.addEditPromo.startTypeError")),
      endDate: Yup.date()
        .required(t("transportSupplierPriceList.addEditPromo.endDateRequired"))
        .typeError(t("transportSupplierPriceList.addEditPromo.endTypeError")),

      percentage: Yup.number()
        .required(
          t("transportSupplierPriceList.addEditPromo.percentageRequired")
        )
        .typeError(
          t("transportSupplierPriceList.addEditPromo.percentageTypeError")
        ),
    };
  }

  const ValidateForm = Yup.object().shape(validateForm);
  const formik = useFormik({
    initialValues: {
      startDate: `${dataFormSearchEdit.startDatetime}`,
      endDate: `${dataFormSearchEdit.endDatetime}`,
      percentage: `${dataFormSearchEdit.percentage}`,
      id: dataFormSearchEdit.id ? `${dataFormSearchEdit.id}` : "",
      supplierId: supplierId2,
    },

    validationSchema: ValidateForm,
    onSubmit: (values) => {
      props.addPriceIncrease(values);
      closeAddMaintenanceModal()
    },
  });

  return (
    <form id="submit1" onSubmit={formik.handleSubmit}>
      <Box sx={{ padding: 20 }}>
        <Dialog
          fullWidth={true}
          PaperProps={{
            sx: {
              maxWidth: "884px !important",
              minHeight: "253px",
              borderRadius: "4px",
            },
          }}
          open={true}
        >
          <DialogTitle>
            <Grid
              container
              alignItems="center"
              alignContent="center"
              direction="row"
            >
              {dataFormSearchEdit.id ? (
                <Grid xs item className="dialogTitleAddition">
                  {t("transportSupplierPriceList.addEditPromo.editModalTitle")}
                </Grid>
              ) : (
                <Grid xs item className="dialogTitleAddition">
                  {t(
                    "transportSupplierPriceList.addEditPromo.createModalTitle"
                  )}
                </Grid>
              )}
              <Grid
                xs
                item
                sx={{ justifyContent: "flex-end", display: "flex" }}
              >
                <CloseIcon
                  color="disabled"
                  fontSize="small"
                  onClick={closeAddMaintenanceModal}
                />
              </Grid>
            </Grid>
          </DialogTitle>

          <DialogContent
            sx={{ borderTop: "1px groove rgba(208, 208, 206, 1)" }}
          >
            <Grid container spacing={2.5} paddingTop={3.5} direction="row">
              <Grid xs item>
                <Box>
                  <>
                    <DatePicker
                         disabled={

                          !!formik.values.startDate.toString()
  
                            ? formik.values.startDate.toString() <
  
                              dayjs().format("YYYY-MM-DD").toString()
  
                              ? true
  
                              : false
  
                            : false
  
                        }
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "startDate",
                          dayjs(e).format("YYYY-MM-DD")
                        );
                      }}
                      mask={"__/__/____"}
                      inputFormat={"DD/MM/YYYY"}
                      value={formik.values.startDate}
                      minDate={dayjs().add(1, "day").toString()}
                      maxDate={
                        formik.values.endDate !== null
                          ? formik.values.endDate
                          : null
                      }
                      renderInput={(params) => (
                        <>
                         <TextField
                            variant="standard"
                            fullWidth
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              placeholder: t(
                                "transportSupplierPriceList.addEditPromo.startValidity"
                              ),
                            }}
                            name="endDate"
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.startDate &&
                              Boolean(formik.errors.startDate)
                            }
                            helperText={
                              formik.touched.startDate &&
                              formik.errors.startDate
                            }
                          />
                        </>
                      )}
                    />
                  </>
                </Box>
              </Grid>
              <Grid xs item>
                <Box>
                  <>
                  <DatePicker
                      disablePast
                      
                      minDate={
                        formik.values.startDate !== null
                          ? formik.values.startDate:null
                      }
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "endDate",
                          dayjs(e).format("YYYY-MM-DD")

                        );

                      }}
                      mask={"__/__/____"}
                      inputFormat={"DD/MM/YYYY"}
                      value={formik.values.endDate}
                      renderInput={(params) => (
                        <>

                          <TextField

                            variant="standard"

                            fullWidth

                            {...params}

                            inputProps={{

                              ...params.inputProps,

                              placeholder: t(

                                "transportSupplierPriceList.addEditPromo.endValidity"

                              ),

                            }}

                            name="endDatetime"

                            onBlur={formik.handleBlur}

                            error={
                              formik.touched.endDate &&
                              Boolean(formik.errors.endDate)

                            }
                            helperText={
                              formik.touched.endDate &&
                              formik.errors.endDate
                            }
                          />
                        </>
                      )}

                    />
                    {/* <DatePicker
                      disablePast
                      minDate={
                        formik.values.startDate !== null
                          ? formik.values.startDate
                          : null
                      }
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "endDate",
                          dayjs.utc(e).format("YYYY-MM-DD")
                        );
                      }}
                      mask={"__/__/____"}
                      inputFormat={"DD/MM/YYYY"}
                      value={formik.values.endDate}
                      renderInput={(params) => (
                        <>
                          <TextField
                            variant="standard"
                            fullWidth
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              placeholder: t(
                                "transportSupplierPriceList.addEditPromo.endValidity"
                              ),
                            }}
                            name="endDate"
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.endDate &&
                              Boolean(formik.errors.endDate)
                            }
                            helperText={
                              formik.touched.endDate &&
                              formik.errors.endDate
                            }
                          />
                        </>
                      )}
                    /> */}
                  </>
                </Box>
              </Grid>

              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="percentage"
                    name="percentage"
                    type="text"
                    value={formik.values.percentage}
                    placeholder={t(
                      "transportSupplierPriceList.addEditPromo.percentage"
                    )}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.percentage &&
                      Boolean(formik.errors.percentage)
                    }
                    helperText={
                      formik.touched.percentage ? formik.errors.percentage : ""
                    }
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions style={{ background: "#F8F8F8" }}>
            <Stack direction="row" spacing={2.875} p={1} mr={3.625}>
              <Button
                variant="outlined"
                size="medium"
                onClick={closeAddMaintenanceModal}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 2.25,
                    color: "#C8017D",
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.cancel")}
                </Typography>
              </Button>
              <Button
                form="submit1"
                variant="contained"
                size="medium"
                type={"submit"}
                color="accent"
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 2.25,
                    color:'white'
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.save")}
                </Typography>
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Box>
    </form>
  );
};
export default PromoIncreaseModal;
